// @flow
import React from 'react';
import { connect } from 'react-redux';

import AbstractCustomNotification, { _mapDispatchToProps, _mapStateToProps } from '../../AbstractCustomNotification';

class CustomNotification<P: Props> extends AbstractCustomNotification<P> {
    constructor(props: P) {
        super(props);
        this._timeout = null;
    }

    componentDidUpdate(prevProps: Readonly<P>): void {
        const { customNotification, onHideCustomNotification } = this.props;

        if (prevProps.customNotification !== customNotification) {
            this._clearTimeout();
            if (customNotification) {
                this._hideBytTimeout();
            } else {
                onHideCustomNotification();
            }
        }
    }

    _clearTimeout() {
        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
    }

    _hideBytTimeout() {
        const { customNotification, onHideCustomNotification } = this.props;

        if (customNotification.timeout) {
            this._timeout = setTimeout(() => {
                onHideCustomNotification();
                this._clearTimeout();
            }, customNotification.timeout);
        }
    }

    onDismissed = () => {
        this.props.onHideCustomNotification();
    };

    render() {
        const { customNotification } = this.props;

        if (customNotification) {
            return (
                <div className='custom-notification' id={customNotification.id}>
                    {React.createElement(customNotification.component, { onDismissed: this.onDismissed,
                        ...customNotification.props })}
                </div>
            );
        }

        return null;

    }
}

export default connect(_mapStateToProps, _mapDispatchToProps)(CustomNotification);
